import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentMethodBankDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4134_556)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 48,
				height: 32,
				rx: 4,
				fill: "url(#paint0_linear_4134_556)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .25,
				y: .25,
				width: 47.5,
				height: 31.5,
				rx: 3.75,
				stroke: "white",
				strokeOpacity: .16,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M27.4807 21.2184C27.4807 21.384 27.615 21.5184 27.7807 21.5184H30.1907C30.3564 21.5184 30.4907 21.384 30.4907 21.2184V14.9284C30.4907 14.7627 30.3564 14.6284 30.1907 14.6284H27.7807C27.615 14.6284 27.4807 14.7627 27.4807 14.9284V21.2184ZM22.9607 21.2184C22.9607 21.384 23.095 21.5184 23.2607 21.5184H25.6807C25.8464 21.5184 25.9807 21.384 25.9807 21.2184V14.9284C25.9807 14.7627 25.8464 14.6284 25.6807 14.6284H23.2607C23.095 14.6284 22.9607 14.7627 22.9607 14.9284V21.2184ZM18.4507 21.2184C18.4507 21.384 18.585 21.5184 18.7507 21.5184H21.1607C21.3264 21.5184 21.4607 21.384 21.4607 21.2184V14.9284C21.4607 14.7627 21.3264 14.6284 21.1607 14.6284H18.7507C18.585 14.6284 18.4507 14.7627 18.4507 14.9284V21.2184ZM24.4707 10.3174C24.8907 10.3174 25.2207 10.6474 25.2207 11.0574V11.0674C25.2207 11.4874 24.8907 11.8174 24.4707 11.8174C24.0607 11.8174 23.7207 11.4874 23.7207 11.0674C23.7207 10.6574 24.0607 10.3174 24.4707 10.3174ZM33.9107 24.0774L33.5307 22.3174C33.4207 21.8574 33.0107 21.5184 32.5407 21.5184H32.2907C32.125 21.5184 31.9907 21.384 31.9907 21.2184V14.9274C31.9907 14.7617 32.125 14.6273 32.2907 14.6273H32.6707C33.3507 14.6273 33.9007 14.0774 33.9007 13.3974V12.8174C33.9007 12.3974 33.6907 12.0073 33.3407 11.7874L25.1407 6.50735C24.7307 6.23735 24.2107 6.23735 23.8007 6.49835L15.6107 11.7874C15.2507 12.0184 15.0407 12.3974 15.0407 12.8174V13.3974C15.0407 14.0774 15.5907 14.6273 16.2707 14.6273H16.6507C16.8164 14.6273 16.9507 14.7617 16.9507 14.9274V21.2184C16.9507 21.384 16.8164 21.5184 16.6507 21.5184H16.4007C15.9307 21.5184 15.5207 21.8574 15.4107 22.3174L15.0307 24.0774C14.9607 24.3773 15.0307 24.6874 15.2307 24.9274C15.4207 25.1674 15.7107 25.2973 16.0107 25.2973H32.9307C33.2407 25.2973 33.5207 25.1674 33.7107 24.9274C33.9107 24.6874 33.9807 24.3773 33.9107 24.0774Z",
				fill: "white",
				fillOpacity: .48
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_4134_556",
		x1: 0,
		y1: 0,
		x2: 48,
		y2: 32,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			stopColor: "white",
			stopOpacity: .04
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "white",
			stopOpacity: .16
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4134_556",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 32,
			fill: "white"
		})
	})] })]
});
export default SvgPaymentMethodBankDark;
